
import axios from "axios";

export const API = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : "http://localhost:8000/api";

// ── Token helpers ─────────────────────────────────────────────────────────────
export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return false;
    const payload = JSON.parse(atob(parts[1]));
    if (!payload.exp) return false;
    if (payload.exp * 1000 < Date.now()) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("email");
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export const getEmailFromToken = () => {
  const token = localStorage.getItem("auth_token");
  if (!isTokenValid(token)) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.email || localStorage.getItem("email") || null;
  } catch {
    return localStorage.getItem("email") || null;
  }
};

// ── Axios instance with auth interceptors ─────────────────────────────────────
const api = axios.create({ baseURL: API });

// Attach Bearer token to every request automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("email");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;